<div class='admissions-prospects-tab-1-part'>
	<application-status-counts-widget></application-status-counts-widget>
</div>